var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineChart3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75H3z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 19.75c-.96 0-1.75-.79-1.75-1.75V9.38c0-.96.79-1.75 1.75-1.75h1.6c.96 0 1.75.79 1.75 1.75V18c0 .96-.79 1.75-1.75 1.75H4zM3.75 9.37V18c0 .14.11.25.25.25h1.6c.14 0 .25-.11.25-.25V9.38c0-.14-.11-.25-.25-.25H4v-.01c-.14 0-.25.11-.25.25zM11.2 19.75c-.96 0-1.75-.79-1.75-1.75V6.19c0-.96.79-1.75 1.75-1.75h1.6c.96 0 1.75.79 1.75 1.75V18c0 .96-.79 1.75-1.75 1.75h-1.6zm-.25-13.56V18c0 .14.11.25.25.25h1.6c.14 0 .25-.11.25-.25V6.19c0-.14-.11-.25-.25-.25h-1.6c-.14 0-.25.11-.25.25zM18.4 19.75c-.96 0-1.75-.79-1.75-1.75V3c0-.96.79-1.75 1.75-1.75H20c.96 0 1.75.79 1.75 1.75v15c0 .96-.79 1.75-1.75 1.75h-1.6zM18.15 3v15c0 .14.11.25.25.25H20c.14 0 .25-.11.25-.25V3c0-.14-.11-.25-.25-.25h-1.6c-.14 0-.25.11-.25.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineChart3);
export default __webpack_public_path__ + "static/media/vuesax-outline-chart-3.7448e2f2c73c469b42568ce2c3dbc348.svg";
export { ForwardRef as ReactComponent };